import { format, parseISO } from 'date-fns'
import { ja } from 'date-fns/locale'
import { FORMAT_DATE_HYPHEN, FORMAT_DATE_JP } from '@/constants'

/**
 * Format Date to JP
 * @param {*} date
 * @returns
 */
export const formatDateJP = (date) => {
  if (!date) return ''

  return format(new Date(date), 'yoMMMdo', {
    locale: ja,
  })
}

export const formatMonthDateJS = (date) => {
  if (!date) return ''

  return format(new Date(date), 'MM月dd', {
    locale: ja,
  })
}

/**
 * Convert date to format yyyy-MM-dd
 * @param {*} input
 * @returns
 */
export const getDateString = (
  input,
  outputTemplate = FORMAT_DATE_HYPHEN,
  defautValue = null,
  options = { locale: ja }
) => {
  try {
    if (!input) {
      return defautValue
    }

    let unixTimestampConvert = 1000

    if (typeof input === 'string') return input

    if (`${input}`.length >= 12) {
      unixTimestampConvert = 1
    }

    let date = new Date(input * unixTimestampConvert).getTime()

    return format(date, outputTemplate, options)
  } catch {
    throw new TypeError('input must be a valid timestamp or date string')
  }
}

export const formatDateStringJP = (dateStr) => {
  if (!dateStr) return ''

  return format(parseISO(dateStr), FORMAT_DATE_JP, { locale: ja })
}

export const formatDateYMD = (date, outputFormat = FORMAT_DATE_HYPHEN) => {
  if (!date) return ''

  return format(new Date(date), outputFormat, {
    locale: ja,
  })
}
